// webviewConstants.js
'use strict';

// UA token the app appends for the webview_flutter creator WebView.
// UA contract with the app: the WebView user agent MUST keep the existing
// 'webview-app' token (so __isOnWebviewApp / the screenshot-allow message
// keep working) and append 'webview-flutter' after it.
export const WEBVIEW_FLUTTER_UA_TOKEN = 'webview-flutter';

// Boot anyway if the app never dispatches its ready event.
export const WEBVIEW_READY_TIMEOUT_MS = 5000;
